import request from '@/utils/home/baseinfo'

export function findcontent(query) {
  return request({
    url: '/api/out/qrcodescantemplate/findcontent',
    method: 'get',
    params: query
  })
}

export function findcontentpic(query) {
  return request({
    url: '/api/out/qrcodescantemplate/findcontentpic',
    method: 'get',
    params: query
  })
}

export function insertcontent(data) {
  return request({
    url: '/api/out/qrcodescantemplate/insertcontent',
    method: 'post',
    data
  })
}

export function insertcontentpics(data) {
  return request({
    url: '/api/out/qrcodescantemplate/insertcontentpic',
    method: 'post',
    data
  })
}
// 删除模板
export function deletecontent(query) {
  return request({
    url: '/api/out/qrcodescantemplate/deletecontent',
    method: 'get',
    params: query
  })
}
// 启用
export function usecontent(query) {
  return request({
    url: '/api/out/qrcodescantemplate/usecontent',
    method: 'get',
    params: query
  })
}